'use client';

import { ReleaseNoteViewers as ReleaseNoteViewersData } from 'bff';
import { useTranslations } from 'i11n';
import { Avatar, AvatarFallback, cn } from 'ui';
import { buildUserFullName, getInitialsFromUser } from 'utils';

// Who in the company already opened the note: the latest few by their
// initials, then how many in all.
export const ReleaseNoteViewers = ({
  viewers,
  className,
}: {
  viewers: ReleaseNoteViewersData;
  className?: string;
}) => {
  const t = useTranslations();

  if (!viewers.count) return null;

  const unnamed = viewers.count - viewers.sample.length;
  const names = viewers.sample.map(buildUserFullName).join(', ');

  return (
    <div
      className={cn('flex items-center gap-2', className)}
      title={names}
      aria-label={names}
    >
      <div className='flex -space-x-1.5'>
        {viewers.sample.map((viewer) => (
          <Avatar
            key={viewer.id}
            size='xs'
            className='bg-white ring-2 ring-white'
          >
            <AvatarFallback className='bg-primary/10 text-[0.625rem] font-semibold text-primary'>
              {getInitialsFromUser(viewer)}
            </AvatarFallback>
          </Avatar>
        ))}
        {unnamed > 0 && (
          <span className='flex h-5 min-w-5 items-center justify-center rounded-full bg-stone-200 px-1 text-[0.625rem] font-semibold text-stone-700 ring-2 ring-white'>
            +{unnamed}
          </span>
        )}
      </div>
      <span className='text-xs text-muted-foreground'>
        {viewers.count === 1
          ? t('release-notes.viewers.one')
          : t('release-notes.viewers.many', { count: viewers.count })}
      </span>
    </div>
  );
};
